import { OptionItem } from "../OptionItem";
import { OptionsOrGroups } from "react-select";
import { GroupItem } from "../GroupItem";

/**
 * Flattens the set of items.
 * @param items The items to flatten.
 * @returns The array of items.
 */
export function flattenItems<TOption extends OptionItem>(items: OptionsOrGroups<TOption, GroupItem<TOption>>): ReadonlyArray<TOption> {
  const result: Array<TOption> = [];

  for (const item of items) {
    if (item.type === "option") result.push(item);
    else if (item.type === "group") result.push(...item.options);
  }

  return result;
}
